import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Check all")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _ctx.postForm,
      "label-width": "120px",
      style: {"width":"80%"},
      rules: _ctx.rules,
      ref: "detailFrom"
    }, {
      default: _withCtx(() => [
        (!_ctx.loginName)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _ctx.$t('table.name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.postForm.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.postForm.name = $event)),
                  maxlength: "6",
                  placeholder: 
            _ctx.$t(
              'input.Please enter Chinese or letters, the length should not exceed 6 characters'
            )
          
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Account'),
          prop: "loginName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.loginName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.postForm.loginName = $event)),
              maxlength: "12",
              placeholder: 
            _ctx.$t(
              'input.The account number can only contain Chinese alphanumeric underscores, no more than 12 characters'
            )
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.password'),
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.postForm.password = $event)),
              type: "password",
              maxlength: "20",
              "show-password": "",
              placeholder: 
            _ctx.$t(
              'input.Please enter a password, the length of which should not exceed 20 characters'
            )
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        (!_ctx.loginName)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _ctx.$t('table.Confirm password'),
              prop: "confirmPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.postForm.confirmPassword,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.postForm.confirmPassword = $event)),
                  "show-password": "",
                  maxlength: "20",
                  placeholder: _ctx.$t('input.Please enter password again')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Manufactor code')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.companyCaptcha,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.postForm.companyCaptcha = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Location save time')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.days,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.postForm.days = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Company')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.company,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.postForm.company = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Email')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.email,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.postForm.email = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Mobile')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.phone,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.postForm.phone = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Telephone')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.mobile,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.postForm.mobile = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, { label: "QQ" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.qq,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.postForm.qq = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.Permission')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.checkAll,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.checkAll = $event)),
              indeterminate: _ctx.isIndeterminate,
              onChange: _ctx.handleCheckAllChange
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue", "indeterminate", "onChange"]),
            _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.postForm.permissionIds,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.postForm.permissionIds = $event)),
              onChange: _ctx.handleCheckedCitiesChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: city.id,
                    label: city.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(city.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Allow login')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.postForm.loginFlag,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.postForm.loginFlag = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Remark')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.postForm.remarks,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.postForm.remarks = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submit()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("table.confirm")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}